<!--
 @description 集群管理-处理集群页
 @author xiehan
 @date 2018/10/16
-->
<template>
  <div class="handlerCluster__content">
    <g-back :history="history" class="ilb" @back="backEvent"></g-back>
    <div class="ilb ml-base">
      <el-button type="primary" 
        @click="save"
        class="ml-base"
        v-g-rac="gRac('handlerCluster@save')" 
        v-text="$t('common.save')"></el-button>
    </div>
    <div>
      <el-form ref="clusterForm" :model="clusterForm" label-width="100px" :rules="rules">
        <el-form-item :label="$t('clusterManager.clusterName')" prop="clusterName">
          <el-input v-model="clusterForm.clusterName"></el-input>
        </el-form-item>
        <div>
          <el-form-item input-width="auto" label-width="0" :inline="true">
            <el-form-item :label="$t('clusterManager.operator')" prop="operator">
              <el-input v-model="clusterForm.operator"></el-input>
            </el-form-item>
            <el-form-item :label="$t('clusterManager.tester')" prop="tester">
              <el-input v-model="clusterForm.tester"></el-input>
            </el-form-item>
          </el-form-item>
        </div>
        <el-form-item input-width="auto" label-width="0" :inline="true">
          <el-form-item :label="$t('clusterManager.remarks')" prop="remarks">
            <el-input v-model="clusterForm.remarks"></el-input>
          </el-form-item>
          <el-form-item :label="$t('clusterManager.envType')" prop="envType">
            <div class="ilb" v-for="(item, key) in select_envType" :key="key">
              <el-radio v-model="clusterForm.envType" :label="key">{{ item }}</el-radio>
            </div>
          </el-form-item>
        </el-form-item>
        <div>
          <el-form-item :label="$t('clusterManager.hostList')" prop="machines" input-width="auto">
            <el-input v-model="inputIPList" @input="inputIPChange" type="textarea"
              style="width: 282px;" :placeholder="$t('clusterManager.ipTips')"></el-input>
            <el-button type="primary" @click="showHostList = !showHostList" v-text="hostListBtnText"></el-button>
            <el-collapse-transition>
              <div v-show="showHostList">
                <label style="color: rgba(0, 0, 0, 0.65);">{{ $t('appManager.belongingGroup') }}</label>
                <el-cascader v-model="selectGroup" :options="options" clearable @change="selectGroupChange"></el-cascader>
                <el-transfer 
                ref="transferForm"
                v-model="clusterForm.machines" 
                :data="hostList" 
                filterable 
                :filter-method="filterHost"
                :titles="hostTitle"
                @change="hostChange"></el-transfer>
              </div>
            </el-collapse-transition>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div style="width: 520px; margin-left: 96px;" v-show="isEdit">
      <el-table
        :data="hostTableData"
        border
        style="width: 100%"
        max-height="350">
        <el-table-column
          v-for="item in hostTableHead"
          :key="item.key"
          :prop="item.key"
          :label="item.label"
          :show-overflow-tooltip="item.showOverflowTooltip">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import cmdbBiz from '@/logic/cmdb/cmdbBiz'
  import appManagerBiz from '@/logic/cmdb/appManagerBiz'
  import ClusterManagerBiz from '@/logic/continuousDelivery/clusterManagerBiz'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        history: [],
        inputIPList: '',
        selectGroup: [],
        options: [],
        clusterForm: {
          clusterName: '',
          operator: '',
          tester: '',
          envType: '1',
          remarks: '',
          machines: []
        },
        rules: {
          clusterName: [
            { required: true, message: this.$t('common.entryTips') + this.$t('clusterManager.clusterName'), trigger: 'blur' }
          ],
          operator: [
            { required: true, message: this.$t('common.entryTips') + this.$t('clusterManager.operator'), trigger: 'blur' }
          ],
          tester: [
            { required: true, message: this.$t('common.entryTips') + this.$t('clusterManager.tester'), trigger: 'blur' }
          ],
          remarks: [
            { required: true, message: this.$t('common.entryTips') + this.$t('clusterManager.remarks'), trigger: 'blur' }
          ],
          machines: [
            { required: true, message: this.$t('common.chooseTips') + this.$t('clusterManager.host'), trigger: 'blur' }
          ]
        },
        select_envType: {},
        select_statusType: {},
        select_agentType: {},
        hostTitle: [],
        hostList: [],
        filterHost (query, item) {
          return String(item['key']).indexOf(query) > -1
        },
        hostListBtnText: this.$t('clusterManager.open'),
        showHostList: false,
        hostTableData: [],
        hostTableHead: [],
        isEdit: false
      }
    },
    components: {},
    methods: {
      init () {
        this.setHistory()
        this.getSiteList()
        if (Object.keys(this.select_envType).length === 0) this.waitEnvType()
        if (Object.keys(this.select_agentType).length === 0) {
          this.waitAgentType()
        } else {
          this.getHostList()
          if (this.isEdit) {
            this.getHostTableData()
            this.getClusterInfo()
            this.$refs.transferForm.clearQuery('left')
            this.$refs.transferForm.clearQuery('right')
          } else {
            this.resetForm()
          }
        }
      },
      backEvent () {
        this.showHostList = false
      },
      setHistory () {
        this.history = []
        this.history.push({ name: this.isEdit ? this.$t('clusterManager.editCluster') : this.$t('clusterManager.addCluster') })
      },
      save () {
        this.$refs['clusterForm'].validate((valid) => {
          if (valid) {
            if (this.$route.query.id) {
              ClusterManagerBiz.newUpdateCluster({ ...this.clusterForm, id: this.$route.query.id }).then(() => {
                this.$message({
                  message: this.$t('common.success'),
                  type: 'success'
                })
                this.showHostList = false
                this.$router.push({ name: 'clusterManager' })
              })
            } else {
              ClusterManagerBiz.saveCluster(this.clusterForm).then(() => {
                this.$message({
                  message: this.$t('common.success'),
                  type: 'success'
                })
                this.showHostList = false
                this.$router.push({ name: 'clusterManager' })
              })
            }
          } else {
            return false
          }
        })
      },
      async waitEnvType () {
        await this.dGetDictionaryByCode('envType')
        this.select_envType = { ...this.dDictionary.envType }
      },
      async waitAgentType () {
        await this.dGetDictionaryByCode('agentType')
        this.select_agentType = { ...this.dDictionary.agentType }
        this.waitStatusType()
      },
      async waitStatusType () {
        await this.dGetDictionaryByCode('ops_status_type')
        this.select_statusType = { ...this.dDictionary.ops_status_type }
        this.getHostList()
        if (this.isEdit) {
          this.getHostTableData()
          this.getClusterInfo()
        }
      },
      getSiteList() {
        cmdbBiz.getAllSiteGroup().then(data => {
          let siteList = []
          data.map(item => {
            let groupList = []
            if (item.groups) {
              item.groups.map(groupsItem => {
                groupList.push(this.transToCascader(groupsItem))
              })
            }
            siteList.push({ ...this.transToCascader(item.siteCode), children: groupList })
          })
          this.options = siteList
        })
      },
      resetForm () {
        this.inputIPList = ''
        this.$refs.transferForm.clearQuery('left')
        this.$refs.transferForm.clearQuery('right')
        this.$refs.clusterForm.clearValidate()
        this.$refs.clusterForm.resetFields()
      },
      getClusterInfo () {
        ClusterManagerBiz.getSingerCluster({ id: this.$route.query.id }).then((data) => {
          this.clusterForm = {
            clusterName: data.clusterName,
            operator: data.operator,
            tester: data.tester,
            envType: data.envType,
            remarks: data.remarks,
            machines: data.machines.length > 0 ? data.machines.map(item => item.host) : []
          }
          this.inputIPList = this.clusterForm.machines.join(',')
        })
      },
      transToCascader(str) {
        return {
          value: str,
          label: str
        }
      },
      selectGroupChange(val) {
        this.getHostList({
          siteCode: val[0],
          group: val[1]
        })
      },
      testIpList(ips) {
        return !!!ips.length || ips.split(',')
          .every(ip => {
            const segments = ip.split('.');
            return segments.length === 4
              && segments
                .map(segment => parseInt(segment, 10))
                  .every(n => n >= 0 && n <= 255);
          });
      },
      inputIPChange (val) {
        const isInputRight = this.testIpList(val)
        if (isInputRight) {
          this.clusterForm.machines = []
          val.split(',').map((item) => {
            if (this.hostList.some(hostItem => hostItem.key === item)) this.clusterForm.machines.push(item)
          })
        } else {}
      },
      hostChange (val) {
        const ipList = val
        this.inputIPList = ipList.join(',')
      },
      getHostTableData () {
        ClusterManagerBiz.getSingerClusterMachine({ perPageCount: 99999, id: this.$route.query.id }).then((data) => {
          this.hostTableHead = [
            { key: 'host', label: this.$t('clusterManager.table.host'), showOverflowTooltip: true },
            { key: 'hostName', label: this.$t('clusterManager.table.hostName'), showOverflowTooltip: true },
            { key: 'status', label: this.$t('clusterManager.table.status'), showOverflowTooltip: true },
            { key: 'agentState', label: this.$t('clusterManager.table.agentState'), showOverflowTooltip: true }
          ]
          if (data && data.dataList && data.dataList.length > 0) {
            let arr = []
            data.dataList.map((item) => {
              let obj = { ...item,
                agentState: this.select_agentType[item.agentState],
                status: this.select_statusType[item.status] }
              arr.push(obj)
            })
            this.hostTableData = arr
          } else {
            this.hostTableData = []
          }
        })
      },
      getHostList (obj) {
        cmdbBiz.hostList({ perPageCount: 99999, ...obj  }).then((data) => {
          if (data && data.dataList) {
            let arr = []
            data.dataList.map(item => {
              let obj = { key: item.ip1, label: item.ip1 }
              arr.push(obj)
            })
            this.hostList = arr
          }
        })
      }
    },
    watch: {
      showHostList (val) {
        this.hostTitle = [this.$t('clusterManager.hostList'), this.$t('clusterManager.choosen')]
        this.hostListBtnText = val ? this.$t('clusterManager.hide') : this.$t('clusterManager.open')
      },
      $route (to, from) {
        if (to.name === 'handlerCluster' && from.name === 'clusterManager') {
          this.isEdit = !!this.$route.query.id
          this.init()
        }
      }
    },
    mounted () {
      this.isEdit = !!this.$route.query.id
      this.init()
    }
  }
</script>

<style scoped>
  .el-form-item--medium {
    display: inline-block;
  }
  .el-radio {
    margin-left: 10px;
  }
</style>